import axios from "axios";
import { decryptCryptoJs } from "../../Helper/crypto";
import { apiLogin } from "./apiLogin";

export const makeRequest = async (url, body) => {

  //return { status: 200, message: [] };

  try {

    const response = await axios.post(
      process.env.REACT_APP_URL_CREDENCIAL + url,
      body || {}, { withCredentials: true }
    );
    return { status: 200, message: response.data };

  } catch (error) {

    // Verifica se o erro é devido a uma sessão expirada (status 401)
    if (error.response && error.response.status === 401) {

      try {
        // Tenta refazer o login
        const userToken = localStorage.getItem("YD7nYJ0l1Wx3");
        const decriptedUser = await decryptCryptoJs(userToken);
        const decripedRes = JSON.parse(decriptedUser);
        await apiLogin(decripedRes);

        // Refazer a requisição original após o login
        const retryResponse = await axios.post(
          process.env.REACT_APP_URL_CREDENCIAL + url,
          body || {}, { withCredentials: true }
        );

        return { status: 200, message: retryResponse.data };

      } catch (loginError) {
        // Se o login falhar, retorne um status 401 para indicar que o usuário precisa ser redirecionado para a tela de login
        return { status: 401, message: "Sessão expirada. Faça login novamente para continuar." };
      }
    } else {

      // Se o erro não for 401, retorne o erro original
      return { status: error.response ? error.response.status : 500, message: "Erro na requisição" };
    }
  }
};